import * as fromRoom from './room.reducer';
import { State } from './room.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

const { selectAll } = fromRoom.roomAdapter.getSelectors();

export const selectRoomState = createFeatureSelector<fromRoom.State>(fromRoom.roomFeatureKey);

export const selectAllRooms = createSelector(selectRoomState, selectAll);

export const selectNewCreatedRoom = createSelector(selectRoomState, (state: State) => state.entities[state.selectedRoomId]);

export const selectRoomByName = (searchString: string) =>
    createSelector(selectAllRooms, (entities) => entities.filter((entity) => entity.name?.toLowerCase().includes(searchString.toLowerCase())));
